import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M5 19h14V5H5v14zM15 7h2v2h-2V7zm0 4h2v2h-2v-2zm-4-4h2v2h-2V7zm0 4h2v2h-2v-2zM7 7h2v2H7V7zm0 4h2v2H7v-2z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M7 7h2v2H7zm0 4h2v2H7z"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "M3 3v18h18V3H3zm16 16H5V5h14v14z"
}, "2"), /*#__PURE__*/_jsx("path", {
  d: "M11 7h2v2h-2zm4 4h2v2h-2zm-4 0h2v2h-2zm4-4h2v2h-2z"
}, "3")], 'MarginTwoTone');